var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNcxwhitelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 33,
    viewBox: "0 0 150 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_3530)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.992 23.5266C114.627 26.2968 112.337 28.6691 109.402 30.3521C106.466 32.0351 103.014 32.9555 99.4699 33.0001C95.9253 33.0447 92.4425 32.2115 89.4495 30.6031C86.4565 28.9947 84.0838 26.681 82.6228 23.9464C80.3739 19.7857 80.3699 13.2441 82.6228 9.08009C84.079 6.34058 86.4495 4.02136 89.4427 2.40795C92.4358 0.794536 95.9209 -0.04265 99.4689 -0.00053826C103.017 0.0415735 106.473 0.961138 109.411 2.64496C112.35 4.32877 114.643 6.70334 116.008 9.47635L116.107 9.67112H112.196L112.148 9.59724C110.953 7.68654 109.187 6.07404 107.027 4.91998C104.867 3.76593 102.388 3.1105 99.8364 3.01883C97.2846 2.92715 94.749 3.40243 92.4814 4.39742C90.2137 5.39242 88.2931 6.87248 86.9104 8.69055C83.6778 12.905 83.6778 20.1081 86.9104 24.3091C88.2928 26.1273 90.2131 27.6076 92.4805 28.6028C94.748 29.5981 97.2835 30.0737 99.8353 29.9824C102.387 29.8911 104.866 29.236 107.026 28.0822C109.186 26.9285 110.952 25.3162 112.148 23.4057L112.196 23.3319H116.107L115.992 23.5266ZM72.6513 28.9499V0.43972H76.2211V32.5633H71.3583L47.1635 4.29146V32.5633H43.5938V0.43972H48.2384L72.6513 28.9499ZM133.198 14.1508L145.533 0.436358H149.999L135.431 16.6358L149.757 32.5633H145.295L133.198 19.1309L121.104 32.5633H116.741L130.953 16.6325L116.388 0.43972H120.855L133.198 14.1508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.807 33V0H38V33H36.807ZM36.807 33L35.5544 0H34.3615L35.6101 33H36.807ZM35.6141 33L33.1088 0H31.9159L34.4211 33H35.6141ZM34.3893 33L30.6195 0H29.4265L33.1804 33H34.3893ZM33.1566 33L28.154 0H26.9611L31.9596 33H33.1566ZM31.9357 33L25.6727 0H24.4598L30.7229 33H31.9357ZM30.711 33L23.1555 0H21.9307L29.4862 33H30.711ZM29.4743 33L20.5986 0H19.3658L28.2057 33H29.4743ZM28.2296 33L18.0854 0H16.8407L26.9849 33H28.2296ZM26.969 33L15.5086 0H14.248L25.6687 33H26.969ZM0 0V33H1.19297V0H0ZM1.19297 0L2.52909 33H3.72206L2.38594 0H1.19297ZM2.38594 0L5.07011 33H6.26308L3.5789 0H2.38594ZM3.59879 0L7.55149 33H8.74446L4.77187 0H3.59879ZM4.82357 0L10.18 33H11.373L6.01256 0H4.82357ZM6.01654 0L12.6574 33H13.8742L7.23336 0H6.01654ZM7.2095 0L15.3058 33H16.5345L8.43826 0H7.2095ZM8.43429 0L18.0973 33H19.338L9.67497 0H8.43429ZM9.66304 0L20.7417 33H21.9983L10.9355 0H9.66304ZM10.9276 0L15.954 12.3293L24.3047 32.8172L24.3763 33H25.6607L25.5613 32.7585L17.2105 12.2672L12.216 0H10.9276Z",
    fill: "url(#paint0_linear_306_3530)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_3530",
    x1: 18.9841,
    y1: 33.1552,
    x2: 18.9841,
    y2: -4.92275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22B4FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#006EF3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_3530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNcxwhitelogo);
export default __webpack_public_path__ + "static/media/ncxwhitelogo.cde82602c5533d882c46d851dca886f0.svg";
export { ForwardRef as ReactComponent };